<template>
  <v-app-bar app scroll-behavior="elevate fade-image" scroll-threshold="100"
    :extended="scrollTop < 100 && $route.path.startsWith('/produtos') && getCategory.banner != null"
    :image="getCategory.banner" extension-height="400">

    <v-app-bar-title ref="appBarTitle" :style="{ color: scrollTop > 60 ? '#000' : titleColor }">
      <span class="ml-15" style="font-size: 1.7rem; font-weight: lighter;">{{ getCategory.name ?
        getCategory.name.toUpperCase() :
        $store.getters.getAppBarTitle }}</span>
    </v-app-bar-title>

    <template v-slot:append>
      <div v-if="getLogged" style="width: 350px;" class="d-flex align-center justify-end">
        <v-text-field variant="solo-filled" placeholder="Buscar Produto" hide-details flat v-model="searchTerm"
          @keyup.enter="searchProducts()">
          <template v-slot:append-inner>
            <v-divider vertical class="my-1 mr-2"></v-divider>
            <v-btn variant="plain" icon="mdi-magnify" density="compact" @click="searchProducts()"></v-btn>
          </template>
        </v-text-field>
      </div>
      <div class="d-flex align-center" :style="{ color: scrollTop > 60 ? '#000' : appendColor }">
        <v-expand-transition>
          <v-btn variant="text" v-if="getLogged && $route.path != '/'" @click="$router.push('/')">
            <v-icon>mdi-home</v-icon>Página inicial
          </v-btn>
        </v-expand-transition>

        <v-menu v-if="getLogged">
          <template v-slot:activator="{ props }">
            <v-btn variant="text" :ripple="false" v-bind="props" append-icon="mdi-menu-down">{{ shortName }}</v-btn>
          </template>
          <v-list>
            <v-list-item key="editar" @click="openPasswordDialog" slim prepend-icon="mdi-key-chain">Alterar
              senha</v-list-item>
            <v-list-item v-for="(item, index) in menuItems" :key="index" :to="item.to" slim :prepend-icon="item.icon">
              {{ item.title }}
            </v-list-item>
            <v-list-item key="sair" @click="logOff" slim prepend-icon="mdi-logout-variant">Sair</v-list-item>
          </v-list>
        </v-menu>

        <v-btn variant="text" @click="openOrderDialog" v-if="getLogged">
          <v-icon>mdi-cart</v-icon>
          <template v-slot:append>
            <v-badge v-if="getCartCount > 0" overlap :content="getCartCount" inline></v-badge>
          </template>
        </v-btn>
      </div>
    </template>
  </v-app-bar>
  <passwordDialog v-if="passwordDialog.show" @close="passwordDialog.show = false" />
  <orderDialog ref="orderDialog" :user="user" />
</template>

<script>
import passwordDialog from "./passwordDialog.vue";
import orderDialog from "./orderDialog.vue";
import { mapState, mapActions, mapGetters } from "vuex";
export default {
  name: "AppBar",
  components: {
    passwordDialog,
    orderDialog,
  },
  data: () => {
    return {
      passwordDialog: {
        show: false,
      },
      scrollTop: 0,
      menuItems: [],
      titleColor: '#000000',
      appendColor: '#000000',
      searchTerm: '',
    };
  },
  computed: {
    ...mapState(["user"]),
    ...mapGetters(["getLogged", "getCategory", "getCartCount"]),
    shortName() {
      const splittedName = this.user.name.split(' ');
      return splittedName.length > 1 ? `${splittedName[0]} ${splittedName[1]}` : splittedName[0];
    },
  },
  watch: {
    'getCategory.banner': {
      handler(newImage) {
        if (newImage) {
          this.updateAppBarColors(newImage);
        } else {
          // Reseta ambas as cores para o padrão
          this.titleColor = '#000000';
          this.appendColor = '#000000';
        }
      },
      immediate: true,
    },
    user(newUser) {
      if (newUser && newUser.level) {
        this.menuItems = [];
        this.$router.options.routes.forEach((route) => {
          if (route.menu && newUser.level <= route.menu.levelId) {
            this.menuItems.push({
              to: route.path,
              icon: route.menu.icon,
              title: route.menu.title,
              order: route.menu.order,
            });
          }
        });
        this.menuItems.sort((a, b) => a.order - b.order);
      }
    }
  },
  methods: {
    ...mapActions(["logOff"]),
    openPasswordDialog() {
      this.passwordDialog.show = true;
    },
    handleScroll() {
      this.scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    },
    async updateAppBarColors(imageUrl) {
      if (typeof window === 'undefined') return;

      const canvas = document.createElement('canvas');
      const context = canvas.getContext('2d', { willReadFrequently: true });
      const img = new Image();
      img.crossOrigin = "Anonymous";
      img.src = imageUrl;

      img.onload = () => {
        canvas.width = img.width;
        canvas.height = img.height;
        context.drawImage(img, 0, 0, img.width, img.height);

        try {
          // --- Análise da Área do Título (Esquerda) ---
          const titleRect = { x: 60, y: 10, width: 300, height: 50 };
          const titleLuminance = this.getLuminanceForArea(context, titleRect);
          this.titleColor = titleLuminance > 128 ? '#000000' : '#FFFFFF';

          // --- Análise da Área dos Botões (Direita) ---
          // A posição X é calculada a partir da direita da imagem
          const appendRect = { x: img.width - 350, y: 10, width: 300, height: 50 };
          const appendLuminance = this.getLuminanceForArea(context, appendRect);
          this.appendColor = appendLuminance > 128 ? '#000000' : '#FFFFFF';

        } catch (e) {
          console.error("Erro ao analisar a imagem para contraste de cor:", e);
          this.titleColor = '#FFFFFF';
          this.appendColor = '#FFFFFF';
        }
      };

      img.onerror = (e) => {
        console.error("Não foi possível carregar a imagem da app-bar:", e);
        this.titleColor = '#000000';
        this.appendColor = '#000000';
      }
    },
    getLuminanceForArea(context, rect) {
      const imageData = context.getImageData(rect.x, rect.y, rect.width, rect.height).data;
      let totalLuminance = 0;
      let pixelCount = rect.width * rect.height;

      for (let i = 0; i < imageData.length; i += 4) {
        const r = imageData[i];
        const g = imageData[i + 1];
        const b = imageData[i + 2];
        const luminance = 0.299 * r + 0.587 * g + 0.114 * b;
        totalLuminance += luminance;
      }
      return totalLuminance / pixelCount;
    },
    openOrderDialog() {
      this.$refs.orderDialog.open();
    },
    searchProducts() {
      if (!this.searchTerm || this.searchTerm.trim() === '') {
        this.$store.dispatch('showErrorSnack', 'Por favor, insira um termo de busca válido.');
        return;
      } else if (this.searchTerm.trim().length < 3) {
        this.$store.dispatch('showErrorSnack', 'Por favor, insira pelo menos 3 caracteres para a busca.');
        return;
      }
      this.$store.dispatch('setCategory', {});
      if( this.$route.name === 'search' && this.$route.params.searchTerm === this.searchTerm) {
        return; // Evita recarregar a mesma busca
      }
      if( this.$route.name != 'search' ) {
        this.$router.push({ name: 'search', params: { searchTerm: this.searchTerm } });
      } else { 
        this.$router.replace({ name: 'search', params: { searchTerm: this.searchTerm } });
      }
      this.searchTerm = '';
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  created() {
    this.menuItems.sort((a, b) => a.order - b.order);
    this.handleScroll();
  },
};
</script>

<style>
.v-app-bar {
  transition: color 0.3s ease-in-out;
}

.v-btn .v-icon {
  color: inherit;
}
</style>